const resources = `JSTOR
Open Access Button
Encyclopedia
OTL - Office of Technology Licensing
ECGpedia
IntechOpen - Open Science Open Minds
Journal of Electrical and Computer Engineering
Electronics
SciAlert Journals
Techopedia: Educando a Profesionales Tecnológicos
ETHOS | Emerging Threat Open Sharing
National Renewable Energy Laboratory (NREL)
National Institute of Standards and Technology
BASE - Bielefeld Academic Search Engine | Indexed content providers by date
OpenAIRE Service Catalogue
Mike Holt Enterprises - the leader in electrical training.
The National Electrical Code (NEC)
Journal of Marketing Analytics | palgrave
IEEE - IEEE Xplore Digital Library
arXiv.org e-Print archive
BMC Biology
CORE – Aggregating the world’s open access research papers
Crossref
ClinicalTrials.gov
DBLP - Computer science bibliography
DOAJ - Directory of Open Access Journals
Digital Public Library of America
ECONBIZ - Find open resources
ERIC - Education Resources Information Center
Europe PMC
Google Scholar
HAL - Archive ouverte
INSPIRE
OpenAlex technical documentation
PLOS
US National Library of Medicine
PubMed
Sistema de Información Científica Redalyc, Red de Revistas Científicas
Semantic Scholar | AI-Powered Research Tool
Google Patents
PQAI: Patent Quality Artificial Intelligence
International Trade Center
Harvard Business Review - Ideas and Advice for Leaders
CEPAL - Publicaciones
UNESCO Biblioteca Digital
CCSE - International Journal of Marketing Studies
Cybersecurity
IADB Publications
World Bank Publications
Communication for Business Success
NIST Standard Reference Materials | NIGMS Collections | Coriell
UNESCO Tesauro
Medline
Merriam-Webster: America's Most Trusted Dictionary
CMS
US Department and Human Service
Springer
Mayo Clinic RSS
AccessScience | McGraw Hill's AccessScience
OpenStax
CDC
HealthIT.gov
Phlebotomy tutorial for medical education - WebPath
Library of Congress
Bartleby Collection
Getty Library: Highlights Open Content Images
Media History Digital Library
Project Gutenberg
Stanford Encyclopedia of Philosophy
American Journal of Economics, AJPO Journals Limited | IDEAS/RePEc
IDEAS - Economics and Finance Research
World Development Indicators | Data Catalog
Countries - The World Factbook
U.S. Census Bureau QuickFacts: United States
Census Bureau Data
PubChem
SafetyLit: Injury Research and Prevention Literature Update
AquaDocs
Medical Career Academy
All About Birds, Cornell Lab of Ornithology
NaturaLista Colombia
iNaturalist
Institute for Economics and Peace
NYPL Digital Collections
Open Access in Psychology
PsychArchives
PsyArXiv Preprints
SSRN
World Travel & Tourism Council
Repositorio Institucional Séneca
Journal of Welding and Joining
Welding in the World | Volume 68, issue 10
International Journal of Refrigeration
OWID Homepage
IEA - Energy System
Global Solar Atlas
NASA POWER | Prediction Of Worldwide Energy Resources
Aviation Safety and Security | Open Access Articles | Digital Commons Network™
AHFE Open Access
FAA Technical Library | Federal Aviation Administration
Revistas Científicas Complutenses. Universidad Complutense de Madrid
MIT Libraries
Investigo
Law Archive Papers
MetaArXiv Preprints
OER Commons
Material Connexion
National Gallery of Art
HKUST-NIE Social Media Lab
Biodiversity Heritage Library
Collection | Carnegie Museum of Art
Federal Reserve Economic Data | FRED | St. Louis Fed
U.S. Bureau of Economic Analysis (BEA)
GitHub - awesomedata/awesome-public-datasets: A topic-centric list of HQ open datasets.
Data USA
European data | data.europa.eu
High Performance Cluster Computing
Mendeley Data
Economic Indicators and Releases - MyNBER
Stanford Large Network Dataset Collection
World Bank Open Data
HealthData.gov
Sociometrics
Pan American Health Organization Publications
World Health Organization Publications
Veterinary Sciences
Pets
Animals
Journal of the American Veterinary Medical Association
American Journal of Veterinary Research
Groomer to Groomer
Frontiers in Veterinary Science
International Journal of Therapeutic Massage & Bodywork Research Education & Practice
Massage Therapy Journal | AMTA
Blood
Blood Advances
Blood Global Hematology
Blood Vessels, Thrombosis & Hemostasis
The Open Nursing Journal
Clinical Nurse Specialist
Holistic Nursing Practice
Emergency Care and Medicine | An Open Access Journal from MDPI
Journal of Emergency and Critical Care Medicine
Western Journal of Emergency Medicine
Journal Of American College of Emergency Physicians
Annals of Emergency Medicine
EMS Prehospital Evidence Based Protocols
Prehospital Emergency Care
Emergency Medicine International
The Open Medical Devices Journal
Pharmacy | An Open Access Journal from MDPI
Pharmacy Practice
FDA Purplebook
Drugs@FDA: FDA-Approved Drugs
OTC Monograph Resources | FDA
ACM Digital Library
Merck Manual Professional Edition
Merck Veterinary Manual
EDUCAUSE Library
Institute For the Future of Education
Glosario de Inteligencia Artificial (IA) para la educación
Observatorio de Inteligencia Artificial en Educación Superior
Open Data Policy Repository
Open Access Biomedical Image
Journal of Imaging
Journal of Dental Materials and Techniques
Restorative Dentistry and Endodontics
Journal of Health Education Teaching
International Journal of First Aid Education
Journal of Social & Health Sciences
Journal of Human Sciences and Extension
The Ultrasound Journal
Journal of Medical Radiation Sciences
International Journal of Air-Conditioning and Refrigeration
Journal of Thermal Engineering
FindLaw
Revista de Cosmetología y Tricología- Revistas de a
Revista Innovación Estética
Cosmetics
Case Reports in Dermatology
Dermatology
Revista Española de Nutrición Humana y Dietética
Revista Cuidarte – DOAJ
Cochrane Library
Trip Medical Database
Agricultural Statistics |USDA Economics, Statistics and Market Information System
U.S. Energy Information Administration (EIA)
OECD Publications
Harvard Dataverse
DASH Repository
CourtListener
Safety and Health at Work | International Labour Organization
Statistics on safety and health at work
ILO Encyclopaedia of Occupational Health and Safety
U.S. Department of Labor : Training and Reference Materials Library | Occupational Safety and Health Administration
American Welding Society  | Standards & Publications - Access Essential Welding Standards
Awesome Library
Center for Astrophysics | Harvard & Smithsonian
GALILEO Open Learning Materials
MERLOT
Repositorio Banco de la República
NASA Technical Reports Server (NTRS)
Fundación EU-LAC/EU-LAC Foundation
AnimalBase
Art & Architecture Thesaurus (Getty Research Institute)
ASCE Library
Jewish Historical Studies: A Journal of English-Speaking Jewry
Jewish Studies | Open Access Articles | Digital Commons Network™
JSIJ - Jewish Studies, an Internet Journal | Faculty of Jewish Studies
Journal of Modern Jewish Studies | Taylor & Francis Online
ChemRxiv | Cambridge Open Engage
Zenodo
OpenICPSR: Behavioral health and social science research data
Open Source in Environmental Sustainability
United Nations Publications
McGraw Hill Business Collection - Spanish Resources
Innerbody
AnatomyZone - Your Guide to Human Anatomy
International Journal of Trichology
Journal of Cosmetology and Trichology- Open Access Journals
Advances in Psychodermatology
Business Perspectives: Problems and Perspectives in Management
Kidney and Blood Pressure Research
Journal of Nephropharmacology
Kidney Research and Clinical Practice
Kidney Medicine | Journal | ScienceDirect.com by Elsevier
Hair Magazine
Hairstyles, Haircuts, Color Ideas, and Trends
Dermatology Journal of Cosmetic and Laser Therapy | Opast Publishing Group
The Association of Religion Data Archives
BSW Biblical Studies on the WEB: your gateway to exegesis on the net
Christian Classics Ethereal Library
Corpus Thomisticum
The Database of Religious History
DigiVatLib
Old Testament Essays
OATD – Open Access Theses and Dissertations
Open Library of Humanities
Pentecostal and Charismatic Research Archive
Semantics of Ancient Hebrew Database
Bible Odyssey
Theological Commons
LibGuides: Open Access Digital Theological Library: Databases
Academic Journals - Journal By Title
ALHATORAH.ORG
Directory of Open Access Books
Paul and Patristics
Research in Ministry
The National Teaching Repository
Digital Education Resource Archive (DERA)
Publications | UNICRI :: United Nations Interregional Crime and Justice Research Institute
The Law Dictionary
Open Access in Law
Revistas Nueva Estetica
Beauty Market Estética. La Revista para la Esteticista Empresaria
Medicina Estética
Esteticamagazine
Telebelleza
PerfectCorp
7 apps de manicura artística para encontrar todos los estilos
Simulador de Uñas IA: Prueba Virtual de Esmalte & Formas | Facetune
Generador de Diseño de Uñas Impulsado por IA | NailDesignsAI
Consejos-tendencias en manicure
Aparatologia Estetica: La Guia Completa - Estetic Rental
BEARD ALFA Productos de Barbería • Peluquería • Cuidado
Masglo | Esmaltes, Bases, Brillos y Más
medicinanaturista.org - Indice de Revistas
Guía de bioseguridad para salones de belleza y centros de estética
NAILS Magazine | Nail Salon Techniques, Nail Art, Business Tips
Nail Pro // Revista especializada en decoración de uñas - Nailistas
Revista Española de Podología
Revista de la Asociación Colombiana de Dermatología y Cirugía Dermatológica
Exposición a agentes químicos de productos cosméticos. BASEQUIM - Portal INSST - INSST
Gale Onefile: Science
Gale OneFile: Nursing and Allied Health
Oceans
Open Access to Ocean Data
World Ocean Database
Ocean Acidification International Coordination Centre (OA-ICC)
Ocean and Coastal Research
Open Access Oceanography Journals · OA.mg
The Ocean Agency - Ocean Image Bank
HSTalks - Multimedia Lectures by Leading World Experts
Intellect Books | Home Page
Institute of Physics - For physics • For physicists • For all : Institute of Physics
Project Euclid
Royal Society of Chemistry
Open Knowledge Repository
The University of Chicago Press: Open Access at Chicago
Journal of Machine Learning Research
Journal of Artificial Intelligence Research
International Journal of Behavioral Nutrition and Physical Activity
Communications Medicine
Journal of Future Foods
Investigación y Educación en Enfermería
International Journal of Biological Sciences
Limnology and Oceanography Letters
International Soil and Water Conservation Research | Journal | ScienceDirect.com by Elsevier
Earth's Future
The Innovation | Journal | ScienceDirect.com by Elsevier
iScience: Cell Press
Global Challenges
Visual Computing for Industry, Biomedicine, and Art
Life Sciences, Society and Policy
Humanities and Social Sciences Communications
Journal of Writing Research
Journal of Social Ontology
Teoría de la Educación. Revista Interuniversitaria
Design Science
Journal of Cultural Analytics
International Journal of Design
Journal of Medical Ethics and History of Medicine
Finance and Society
Heritage
Revista Signos. Estudios de Lingüística
Revista Española de Educación Comparada
Círculo de Lingüística Aplicada a la Comunicación
Studies in English Language and Education
Management Science | PubsOnLine
Virtual Economics
Data Science and Management
Digital Business
Financial Innovation
Spanish Journal of Marketing - ESIC | Emerald Publishing
Big Data and Cognitive Computing | An Open Access Journal from MDPI
Journal of Economics and Development Studies (JEDS)
Journal of Responsible Innovation | Taylor & Francis Online
Science Advances | AAAS
Scientific Reports
Science Progress
Big Data & Society
International Journal of Information Management Data Insights | ScienceDirect.com by Elsevier
Telematics and Informatics | Journal | ScienceDirect.com by Elsevier
Educational Technology & Society
Journal of Engineering Education
The Lancet Digital Health
Journal of Health Equity
International Journal of Behavioral Nutrition and Physical Activity
Innovation in Aging
Complementary Therapies in Medicine | Journal | ScienceDirect.com by Elsevier
Education Sciences | An Open Access Journal from MDPI
Chiropractic & Manual Therapies
Human Factors in Healthcare
Revista Vida Estética & Spa - Edición Americana
Fotor
Alzheimer's Association Tools and Resources
American Society of Ichthyologists and Herpetologists
CDC Oral Health
Cognition and Instruction
Dryad | Publish and preserve your data
Diccionario RAING
Filmsite
Medscape Reference: Drugs, Diseases & Medical Procedures
ASCP Podcasts
Beauty Launchpad
Behindthechair.com | Education & Inspiration for Professional Hairstylists
Occupational Outlook Handbook
Cosmetology State Board Exam Practice Test Questions & Answers - Quiz & Trivia
FDA on Cosmetics
Cosmetology - Hair, Haistyles, Hair Loss and Removal Web Resources
Skincare Advice
Webinars - Modern Salon
eBooks - Modern Salon
Strong's Exhaustive Concordance - Wikisource, the free online library
BLB Bible Concordances
My Open Bible - Online Study Bible
Cahiers du Cinéma
American Indian Film Gallery
Bright Lights Film Journal
Film-Philosophy
Widescreen Journal
Cooperative Digital Resources Initiative (CDRI) - Atla Digital Library
Early Christian Writings: New Testament, Apocrypha, Gnostics, Church Fathers
Global Industry Market Sizing
Internet History Sourcebooks Project: Ancient History
Perseus Digital Library
Tips on the Power of Being Punctual [You Are in Control, Discipline, and it Can Be Cultivated] - YouTube
⏰ Punctuality: The Secret to Success! | Boost Your Discipline & Achieve More Today - YouTube
#TheBetterWay (e21) Professional Appearance - YouTube
What to Wear For a Technician or Mechanic Job Interview - YouTube
La ética en el trabajo: ejemplos de la vida real y su importancia - YouTube
Professionalism in the Workplace - YouTube
WHO guideline on HIV service delivery
G-W Online Textbooks
Hair Colour for Hairstylists: Level 2
The Open University's Carbon Calculator
Induction/flame hardening | OpenLearn - Open University
Compression moulding
Chemical vapour deposition (CVD)
HVAC - Cold Climate Heat Pump Sizing | Building Science Education
Journal Information | npj Urban Sustainability
Energy and AI | Journal | ScienceDirect.com by Elsevier
Materials & Design | Journal | ScienceDirect.com by Elsevier
Sustainable Materials and Technologies | Journal | ScienceDirect.com by Elsevier
Developments in the Built Environment | Journal | ScienceDirect.com by Elsevier
Resilient Cities and Structures | Journal | ScienceDirect.com by Elsevier
International Journal of Concrete Structures and Materials
Journal of Infrastructure Intelligence and Resilience | ScienceDirect.com by Elsevier
Journal of Information Technology in Construction
Philosophy, Ethics, and Humanities in Medicine
Conductual
Asian-Pacific Journal of Second and Foreign Language Education
European Journal of Educational Research
Cogent Education
Education Sciences
Curriculum and Teaching Methodology
English Education:Journal of English Teaching and Research
Cursos MOOC - Cursos Masivos Abiertos y en Línea -
MOOCs, Opción Gratuita y de Alta Calidad | Uniandes
Principales cursos sobre Mooc - Aprende sobre Mooc en línea.
Udemy: cursos en línea para habilidades, carreras profesionales e IA
Página Principal | IIFAC-MOOC
The Disinformation Age
American Journal of International Law | Cambridge Core
British Actuarial Journal
German Law Journal
Proceedings of the Design Society
Frontiers in Artificial Intelligence
Frontiers in Big Data
Frontiers in Blockchain
Frontiers in Built Environment
Frontiers in Child and Adolescent Psychiatry
Frontiers in Communication
Frontiers in Communications and Networks
Frontiers in Developmental Psychology
Frontiers in Disaster and Emergency Medicine
Frontiers in Education
Frontiers in Freshwater Science
Frontiers in Language Sciences
Frontiers in Marine Science
Frontiers in Materials
Frontiers in Ocean Sustainability
Frontiers in Organizational Psychology
Frontiers in Pharmacology
Frontiers in Physiology
Frontiers in Rehabilitation Sciences
Frontiers in Social Psychology
Frontiers in Sports and Active Living
Frontiers in Sustainable Tourism
Principales cursos sobre Art - Aprende sobre Art en línea.
Tecnologías de la información Online Courses`;

export const quoteResources = [...new Set(resources.split('\n'))].sort((a, b) =>
	a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true }),
);
